import { memo, useMemo, useRef, MouseEventHandler } from 'react';
import classNames from 'classnames';
import './upload-picture-example.scss';
interface IProps {
    showMode?: 'display' | 'translateY' | 'heightChange';
    title: string;
    onClose?: MouseEventHandler;
    visible: boolean;
    maxHeight?: string;
    className?: string;
}

const UploadPictureExample = ({ title, onClose, showMode = 'display', visible, maxHeight, className }: IProps) => {
    const examples = useRef([
        {
            id: 1,
            title: '保持题目信息清晰、完整',
            correct: 'https://simg01.gaodunwangxiao.com/uploadfiles/files/202408/26/1ba84_20240826140825.png',
            error: 'https://simg01.gaodunwangxiao.com/uploadfiles/files/202408/26/8b7af_20240826140804.png',
        },
        {
            id: 2,
            title: '拍照时保证光线充足',
            correct: 'https://simg01.gaodunwangxiao.com/uploadfiles/files/202408/26/8783c_20240826140908.png',
            error: 'https://simg01.gaodunwangxiao.com/uploadfiles/files/202408/26/2c3bd_20240826140919.png',
        },
        {
            id: 3,
            title: '一次框选一道题目，识别更准确',
            correct: 'https://simg01.gaodunwangxiao.com/uploadfiles/files/202408/26/f6ed3_20240826141009.png',
            error: 'https://simg01.gaodunwangxiao.com/uploadfiles/files/202408/26/22db5_20240826141021.png',
        },
        {
            id: 4,
            title: '综合题只需拍小题题干',
            correct: 'https://simg01.gaodunwangxiao.com/uploadfiles/files/202408/26/45abe_20240826141137.png',
            error: 'https://simg01.gaodunwangxiao.com/uploadfiles/files/202408/26/4cbf5_20240826141123.png',
        },
        {
            id: 5,
            title: '手写题目可能识别不准确，持续优化中...',
            correct: 'https://simg01.gaodunwangxiao.com/uploadfiles/files/202408/26/3e9c8_20240826141254.png',
            error: 'https://simg01.gaodunwangxiao.com/uploadfiles/files/202408/26/057d8_20240826141306.png',
        },
    ]);

    const style = useMemo(() => {
        if (showMode === 'display') return { display: visible ? 'block' : 'none' };
        if (showMode === 'translateY')
            return {
                transition: 'transform 0.3s cubic-bezier(0.69, -0.02, 0.17, 0.94)',
                transform: `translateY(${visible ? '0' : '110%'})`,
            };
        if (showMode === 'heightChange')
            return {
                transition: 'transform 0.3s cubic-bezier(0.69, -0.02, 0.17, 0.94)',
                transform: visible ? 'translate(0, 0) scale(1)' : `translate(200px, 55%) scale(0)`,
            };
        return {};
    }, [showMode, visible, maxHeight]);

    return (
        <>
            {visible && showMode === 'translateY' && <div className="upload-picture-example-overlay" onClick={onClose}></div>}
            <div className={classNames('upload-picture-example', className)} style={style} onClick={ev => ev.stopPropagation()}>
                <header className="upload-picture-example__header">
                    <span>{title}</span>
                    {onClose && <div className="upload-picture-example__close" onClick={onClose} />}
                </header>
                <div className="upload-picture-example__examples-container" style={{ maxHeight }}>
                    {examples.current.map((item, index) => (
                        <div key={item.id} className="upload-picture-example__item">
                            <div className="upload-picture-example__title">
                                <div className="upload-picture-example__index">{index + 1}</div>
                                <span>{item.title}</span>
                            </div>
                            <div className="upload-picture-example__examples">
                                <div
                                    className="upload-picture-example__correct-example"
                                    style={{ backgroundImage: `url(${item.correct})` }}
                                />
                                <div className="upload-picture-example__error-example" style={{ backgroundImage: `url(${item.error})` }} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default memo(UploadPictureExample);
